// eslint-disable-next-line no-restricted-imports
import _ from 'lodash'

import generatePriceFilters from './generatePriceFilters'

export default function getFilters(items, filters) {
  const categoryFilterTypes = {}
  const productPrices = []
  items.forEach(product => {
    if (product.filterIds) {
      product.filterIds.forEach(filterId => {
        const websiteFilter = filters.find(wf => wf._id === filterId)
        if (!websiteFilter) return
        let quantity = 1
        if (
          categoryFilterTypes[websiteFilter.type] &&
          categoryFilterTypes[websiteFilter.type][filterId]
        ) {
          quantity = categoryFilterTypes[websiteFilter.type][filterId].quantity + 1
        }
        categoryFilterTypes[websiteFilter.type] = {
          ...categoryFilterTypes[websiteFilter.type],
          [filterId]: {
            filterName: websiteFilter.filterName,
            value: false,
            type: websiteFilter.type,
            quantity
          }
        }
      })
    }

    if (
      product.availabilityAt &&
      product.availabilityAt.available &&
      product.availabilityAt.finalPrice
    ) {
      productPrices.push(product.availabilityAt.basePrice)
    }
  })

  const sortedFilters = _(categoryFilterTypes).toPairs().sortBy(0).fromPairs().value()
  return {
    categoryFilterTypes: sortedFilters,
    generatedPriceFilters: generatePriceFilters(productPrices)
  }
}
